import { BottomSheetDialog } from '@medely/web-components';
import React from 'react';
import { Button } from '@medely/ui-kit';
import useDevice from '@mp/hooks/useDevice.web';
import { StipendModalInfo } from './StipendModalInfo';
import { StipendModalProps } from './types';

export const StipendModal = ({ open, onClose }: StipendModalProps) => {
  const isDesktop = useDevice() === 'desktop';

  return (
    <BottomSheetDialog
      open={open}
      onClose={onClose}
      title="Tax free stipend"
      content={<StipendModalInfo />}
      actions={
        <Button variant="outlined" onClick={onClose} testId="stipend-modal-close-button" fullWidth>
          Close
        </Button>
      }
      isDesktop={isDesktop}
    />
  );
};
